import React from 'react';
import { Shield, Award, CheckCircle, Clock, ShieldCheck, Wrench, BadgeCheck, Star } from 'lucide-react';

const TrustBadges = () => {
  return (
    <section className="py-20 bg-[#050505]">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Why Saskatoon Trusts Us
          </h2>
          <p className="text-xl text-neutral-400 font-medium">
            Professional, verified, and fully warranted service you can count on
          </p>
        </div>

        {/* Trust Badges Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto mb-16">
          
          {/* Badge 1: Police Verified */}
          <div className="bg-[#0F0F11] border border-[#D4AF37]/30 p-6 rounded-lg shadow-lg hover:shadow-[0_8px_32px_rgba(212,175,55,0.2)] hover:border-[#D4AF37] transition-all">
            <div className="flex justify-center mb-4">
              <div className="bg-[#D4AF37]/10 p-4 rounded-lg">
                <ShieldCheck size={40} className="text-[#D4AF37]" />
              </div>
            </div>
            <h3 className="text-xl font-black text-white mb-2 text-center">
              Police-Verified Technicians
            </h3>
            <p className="text-neutral-400 text-center font-medium">
              All our technicians have passed criminal background checks
            </p>
          </div>

          {/* Badge 2: Experience */}
          <div className="bg-[#0F0F11] border border-[#D4AF37]/30 p-6 rounded-lg shadow-lg hover:shadow-[0_8px_32px_rgba(212,175,55,0.2)] hover:border-[#D4AF37] transition-all">
            <div className="flex justify-center mb-4">
              <div className="bg-[#D4AF37]/10 p-4 rounded-lg">
                <Award size={40} className="text-[#D4AF37]" />
              </div>
            </div>
            <h3 className="text-xl font-black text-white mb-2 text-center">
              8+ Years Experience
            </h3>
            <p className="text-neutral-400 text-center font-medium">
              Trusted professionals serving Saskatoon since 2016
            </p>
          </div>

          {/* Badge 3: High-Cycle Springs */}
          <div className="bg-[#0F0F11] border border-[#D4AF37]/30 p-6 rounded-lg shadow-lg hover:shadow-[0_8px_32px_rgba(212,175,55,0.2)] hover:border-[#D4AF37] transition-all">
            <div className="flex justify-center mb-4">
              <div className="bg-[#D4AF37]/10 p-4 rounded-lg">
                <Wrench size={40} className="text-[#D4AF37]" />
              </div>
            </div>
            <h3 className="text-xl font-black text-white mb-2 text-center">
              25,000+ Cycle Springs
            </h3>
            <p className="text-neutral-400 text-center font-medium">
              High-quality springs that last 2-3x longer than standard
            </p>
          </div>

          {/* Badge 4: Full Warranty */}
          <div className="bg-[#0F0F11] border border-[#D4AF37]/30 p-6 rounded-lg shadow-lg hover:shadow-[0_8px_32px_rgba(212,175,55,0.2)] hover:border-[#D4AF37] transition-all">
            <div className="flex justify-center mb-4">
              <div className="bg-[#D4AF37]/10 p-4 rounded-lg">
                <Shield size={40} className="text-[#D4AF37]" />
              </div>
            </div>
            <h3 className="text-xl font-black text-white mb-2 text-center">
              Full Parts & Labor Warranty
            </h3>
            <p className="text-neutral-400 text-center font-medium">
              Every installation and repair is 100% warranted
            </p>
          </div>

          {/* Badge 5: Galvanized Steel */}
          <div className="bg-[#0F0F11] border border-[#D4AF37]/30 p-6 rounded-lg shadow-lg hover:shadow-[0_8px_32px_rgba(212,175,55,0.2)] hover:border-[#D4AF37] transition-all">
            <div className="flex justify-center mb-4">
              <div className="bg-[#D4AF37]/10 p-4 rounded-lg">
                <ShieldCheck size={40} className="text-[#D4AF37]" />
              </div>
            </div>
            <h3 className="text-xl font-black text-white mb-2 text-center">
              Galvanized Steel Parts
            </h3>
            <p className="text-neutral-400 text-center font-medium">
              Rust-resistant, durable materials built for Saskatchewan weather
            </p>
          </div>

          {/* Badge 6: 24/7 Emergency */}
          <div className="bg-[#0F0F11] border border-[#D4AF37]/30 p-6 rounded-lg shadow-lg hover:shadow-[0_8px_32px_rgba(212,175,55,0.2)] hover:border-[#D4AF37] transition-all">
            <div className="flex justify-center mb-4">
              <div className="bg-[#D4AF37]/10 p-4 rounded-lg">
                <Clock size={40} className="text-[#D4AF37]" />
              </div>
            </div>
            <h3 className="text-xl font-black text-white mb-2 text-center">
              24/7 Emergency Service
            </h3>
            <p className="text-neutral-400 text-center font-medium">
              Available anytime, day or night, for urgent repairs
            </p>
          </div>

          {/* Badge 7: Licensed & Insured */}
          <div className="bg-[#0F0F11] border border-[#D4AF37]/30 p-6 rounded-lg shadow-lg hover:shadow-[0_8px_32px_rgba(212,175,55,0.2)] hover:border-[#D4AF37] transition-all">
            <div className="flex justify-center mb-4">
              <div className="bg-[#D4AF37]/10 p-4 rounded-lg">
                <BadgeCheck size={40} className="text-[#D4AF37]" />
              </div>
            </div>
            <h3 className="text-xl font-black text-white mb-2 text-center">
              Licensed & Insured
            </h3>
            <p className="text-neutral-400 text-center font-medium">
              Fully certified and insured for your protection
            </p>
          </div>

          {/* Badge 8: Commercial & Residential */}
          <div className="bg-[#0F0F11] border border-[#D4AF37]/30 p-6 rounded-lg shadow-lg hover:shadow-[0_8px_32px_rgba(212,175,55,0.2)] hover:border-[#D4AF37] transition-all">
            <div className="flex justify-center mb-4">
              <div className="bg-[#D4AF37]/10 p-4 rounded-lg">
                <CheckCircle size={40} className="text-[#D4AF37]" />
              </div>
            </div>
            <h3 className="text-xl font-black text-white mb-2 text-center">
              Commercial & Residential
            </h3>
            <p className="text-neutral-400 text-center font-medium">
              Expert service for homes and businesses
            </p>
          </div>
        </div>

        {/* Warranty Callout Box */}
        <div className="max-w-5xl mx-auto bg-gradient-to-r from-[#0F0F11] to-[#16161A] border border-[#D4AF37]/30 rounded-xl p-10 shadow-2xl">
          <div className="text-center mb-8">
            <Shield size={64} className="mx-auto mb-4 text-[#D4AF37]" />
            <h3 className="text-3xl font-black mb-4 text-white">Our Warranty Promise</h3>
            <p className="text-xl text-neutral-300 font-medium mb-6">
              Every job comes with comprehensive warranty coverage
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div className="bg-[#050505] border border-white/10 p-6 rounded-lg">
              <h4 className="font-black text-xl mb-2 text-[#D4AF37]">Parts Warranty</h4>
              <p className="text-neutral-400">All garage door parts and components covered</p>
            </div>
            <div className="bg-[#050505] border border-white/10 p-6 rounded-lg">
              <h4 className="font-black text-xl mb-2 text-[#D4AF37]">Labor Warranty</h4>
              <p className="text-neutral-400">Workmanship and installation guaranteed</p>
            </div>
            <div className="bg-[#050505] border border-white/10 p-6 rounded-lg">
              <h4 className="font-black text-xl mb-2 text-[#D4AF37]">Full Support</h4>
              <p className="text-neutral-400">Ongoing support and maintenance available</p>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="text-center mt-12">
          <p className="text-xl text-neutral-300 font-semibold mb-4">
            Experience the difference
          </p>
          <a 
            href="tel:306-262-5995" 
            className="inline-block text-3xl font-black text-[#D4AF37] hover:text-[#F0C84A] transition-colors"
          >
            📞 306-262-5995
          </a>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
